// @ts-nocheck
import { getIsProductPriceLoading } from "@store/Framework/Store/Store/Data/Products/ProductsSelectors";
import convertSelectorToHooks from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useIsProductPriceLoading = convertSelectorToHooks(getIsProductPriceLoading);
